import apiClient from "./axios";

// Human label: "{BRTA code}-{last 4 digits}" e.g. "Dhaka Metro Gha-18-8754"
export const brtaRegLabel = registration =>
  [registration?.brtaCode?.name, registration?.brta_number]
    .map(part => (part == null ? "" : String(part).trim()))
    .filter(Boolean)
    .join("-");

export const getBrtaRegistrations = async (params = {}) => {
  const { data } = await apiClient.get("/brta-registrations", { params });
  return data;
};

export const getBrtaRegistration = async id => {
  const { data } = await apiClient.get(`/brta-registrations/${id}`);
  return data;
};

export const createBrtaRegistration = async data => {
  const { data: response } = await apiClient.post("/brta-registrations", data);
  return response;
};

export const editBrtaRegistration = async ({ id, ...data }) => {
  const { data: response } = await apiClient.patch(`/brta-registrations/${id}`, data);
  return response;
};

export const deleteBrtaRegistration = async id => {
  const { data } = await apiClient.delete(`/brta-registrations/${id}`);
  return data;
};
